<template>
  <div class="editor-container">
    <div style="height:100%">
      <Row style="height:4%">
        <Col span="8" class="field">
          <Input v-model="title" prefix="ios-grid-outline" placeholder="文章标题" />
        </Col>
        <Col span="8" class="field">
          <Input v-model="uri" prefix="md-link" placeholder="URI" />
        </Col>
        <Col span="6" class="field">
          <Input v-model="tags" prefix="md-pricetags" placeholder="标签" />
        </Col>
        <Col span="2" class="field">
          <Select v-model="status" v-if="this.ID>0" @on-change="this.statusChange">
            <Option :value="0" :key="'opt-1'">草稿</Option>
            <Option :value="1" :key="'opt-2'">已发布</Option>
          </Select>
          <Icon type="ios-loading" class="load" v-if="isLoading"/>
        </Col>
      </Row>
      <Row style="height:95%">
        <Col span="24" class="field editor" style="height:100%">
          <markdown-editor v-model="content" :local-cache="false" @save="handleSave" @auto-save="autoSave" v-if="type==1" style="height:100%"/>
          <editor v-model="content" :cache="false" @save="handleSave" v-if="type==0"/>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { getArticleDetail, saveArticle, publishArticle, getArticleMD5 } from '@/api/data'
import MarkdownEditor from '_c/markdown'
import Editor from '_c/editor'

export default {
  name: 'article_edit_page',
  components: {
    MarkdownEditor,
    Editor
  },
  data: function () {
    return {
      ID: 0,
      title: '',
      uri: '',
      tags: '',
      content: '',
      type: -1,
      status: 0,
      isLoading: false
    }
  },
  methods: {
    ...mapMutations([
      'setTagNavSubtitle'
    ]),
    info (title, desc) {
      this.$Notice.info({
        title, desc
      })
    },
    success (title, desc) {
      this.$Notice.success({
        title, desc
      })
    },
    warning (title, desc) {
      this.$Notice.warning({
        title, desc
      })
    },
    error (title, desc) {
      this.$Notice.error({
        title, desc
      })
    },
    loadPage () {
      this.isLoading = true
      var _this = this
      getArticleDetail(this.$route.params.id).then(res => {
        if (res.data.ok) {
          _this.ID = res.data.data.id
          _this.title = res.data.data.title
          _this.uri = res.data.data.uri
          _this.tags = res.data.data.tags.join(',')
          _this.content = res.data.data.content
          _this.type = res.data.data.type
          _this.status = res.data.data.status
          _this.isLoading = false
          _this.setTagNavSubtitle({ route: this.$route, subtitle: this.title })
        } else {
          _this.error('加载文章失败', resp.data.msg)
        }
      })
    },
    statusChange (status) {
      console.log('status change -->', status)
      var _this = this
      publishArticle(this.ID, status === 1).then(resp => {
        if (resp.data.ok) {
          _this.success('修改状态成功', '')
        } else {
          _this.warning('修改状态失败', resp.data.msg)
        }
      })
    },
    autoSave (ctt) {
      let _this = this
      getArticleMD5(this.ID).then(resp => {
        if (resp.data.ok) {
          if (resp.data.data.md5 !== _this.$md5(ctt)) {
            _this.handleSave(ctt)
          }
        }
      })
    },
    handleSave (ctt) {
      console.log('title:', this.title)
      if (this.title === '') {
        this.info('错误', '无标题，不能保存')
        return
      }

      var _this = this
      var tags = []
      if (this.tags !== '') {
        this.tags = this.tags.replaceAll('，', ',')
        tags = this.tags.split(',')
      }

      saveArticle(this.ID, this.title, this.uri, tags, (ctt && ctt !== '') ? ctt : this.content, this.type).then(resp => {
        if (resp.data.ok) {
          _this.success('保存成功', '')
        } else {
          _this.warning('保存失败', resp.data.msg)
        }
      })
    }
  },
  mounted: function () {
    this.loadPage()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  watch: {
    '$route' (to, from) {
      if (to.path !== from.path) {
        this.loadPage()
      }
    }
  }
}
</script>

<style scoped>
.field {
  padding:0 10px;
}
.editor {
  margin: 10px 0;
}
@keyframes spin {
  0%   { transform: rotate(360deg); }
  100% { transform: rotate(0deg); }
}
.load {
  margin: 0 10px;
  animation: spin 800ms infinite linear;
}
.editor-container{
  width: 100%;
  height: 100%;
}
.editor-container .ivu-card{
  height: 100%;
}
</style>
